import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface StartAssessmentRequest {
  companyName: string;
  sector: string;
  userRole: string;
}

export interface AssessmentResponse {
  assessmentId: string;
  companyName: string;
  sector: string;
  question: string;
  progress: number;
  suggestedAnswers?: string[];
}

export interface SubmitAnswerResponse {
  nextQuestion?: string;
  progress: number;
  isComplete: boolean;
  currentScore?: number;
  suggestedAnswers?: string[];
}

export interface AssessmentResults {
  assessmentId: string;
  companyName: string;
  sector: string;
  aiReadinessScore: number;
  breakdown?: {
    technology: number;
    dataAnalytics: number;
    organization: number;
    businessCase: number;
  };
  responses: Record<string, any>;
  createdAt: string;
}

export const assessmentService = {
  startAssessment: async (data: StartAssessmentRequest): Promise<AssessmentResponse> => {
    const response = await apiClient.post('/assessment/start', data);
    return response.data.data;
  },

  submitAnswer: async (
    assessmentId: string, 
    question: string, 
    answer: string
  ): Promise<SubmitAnswerResponse> => {
    const response = await apiClient.post('/assessment/answer', {
      assessmentId,
      question,
      answer
    });
    return response.data.data;
  },

  getResults: async (assessmentId: string): Promise<AssessmentResults> => {
    const response = await apiClient.get(`/assessment/${assessmentId}/results`);
    return response.data.data;
  },

  getStatus: async (assessmentId: string) => {
    const response = await apiClient.get(`/assessment/${assessmentId}/status`);
    return response.data.data;
  }
};

// Add response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    
    if (error.response) {
      // Server responded with error status
      const message = error.response.data?.error?.message || 'Errore del server';
      throw new Error(message);
    } else if (error.request) {
      // Request made but no response received
      throw new Error('Errore di connessione. Verifica la tua connessione internet.');
    } else {
      // Something else happened
      throw new Error('Errore imprevisto. Riprova tra qualche minuto.');
    }
  }
);